/** @format */

import { ProductSku } from '@shared/data-access/interfaces';
import { AttributeOption } from '@pdp/data-access/interfaces';

export interface AttributeSelectedActionProps {
  allProductSkus: ProductSku[];
  selectedAttribute: AttributeOption;
  isApparelOrFootwear?: boolean;
}
